import { TAnswerValue } from './types';

export const trackingValue = (
  questionId: string,
  value: TAnswerValue,
): string | undefined => {
  if (value === undefined) return undefined;

  // Kept at all four published score classes even though scoring merges the middle two —
  // buckets can be aggregated later, but a boundary we never recorded can't be recovered.
  if (questionId === 'schufaScore' && typeof value === 'number') {
    if (value < 642) return '100-641';
    if (value < 709) return '642-708';
    if (value < 776) return '709-775';
    return '776-999';
  }

  if (questionId === 'crefoIndex' && typeof value === 'number') {
    if (value < 150) return '100-149';
    if (value < 200) return '150-199';
    if (value < 250) return '200-249';
    if (value < 300) return '250-299';
    if (value < 350) return '300-349';
    if (value < 500) return '350-499';
    return '500-600';
  }

  return String(value);
};
